import { Button, DatePicker, Form, Input, message, Popconfirm, Select, Space } from "antd";
import { serverFetch } from "../../server";
import { storeDocVids } from "../../extensions/helper";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { strDate2Server } from "../../extensions/utils";
import SelectClient from "../../controls/select-client/select-client";
import { LogMonitor } from "@/controls";
import ButtonReport from "@/controls/button-report";
import { isMobile } from "@/extensions/design";

const StockDocMain = ({ id, onClose, setVid, refreshKey = 0 }) => {
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`store/${id}`)
        .then(data => {
            setLoading(false);
            const newItem = {...data, docDate: dayjs(data.docDate) }
            setItem(newItem);
            form.setFieldsValue(newItem);
            setVid(newItem.vid);
        })
        .catch(e => {
            setLoading(false);
            message.error(e.userMessage);
        })
    }
    else {
      const newItem = { docDate: dayjs(), comment: "", vid: 1, };
      form.setFieldsValue(newItem);
      setItem(newItem);
    }
  }

  useEffect(getData, [id, refreshKey]);

  const onSave = () => {
    setLoading(true);
    serverFetch("store", { method: id ? "PUT" : "POST", bodyData: { ...item, docDate: strDate2Server(item.docDate) } })
      .then(data => {
        setLoading(false);
        onClose(data.id);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onDelete = () => {
    setLoading(true);
    serverFetch(`store/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onValuesChange = value => {
    setItem({...item, ...value});
    value.vid && setVid(value.vid);
  }

  const onActivate = () => {
    setLoading(true);
    serverFetch(`store/DocSetActive?id=${id}&active=true`, { method: "PUT" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onDeactivate = () => {
    setLoading(true);
    serverFetch(`store/DocSetActive?id=${id}&active=false`, { method: "PUT" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const getObjectIn = () => {
    if (item?.vid === 1) 
      return <Form.Item label="Поставщик" className={ !isMobile ? "" : "record-form-item-with-margin-top-mobile"}>
        <SelectClient onChange={e => onValuesChange({ clientOutId: e.value})} value={item?.clientOutId} 
          defOptions={[{value: item.clientOutId, label: item.clientOutName}]}/>
      </Form.Item>
    return null;
  }

  const getObjectOut = () => {
    if (item?.vid === -1) 
      return <Form.Item label="Получатель" className={ !isMobile ? "" : "record-form-item-with-margin-top-mobile"}>
        <SelectClient onChange={e => onValuesChange({ clientInId: e.value})} value={item?.clientInId}
          defOptions={[{value: item.clientInId, label: item.clientInName}]}/>
      </Form.Item>
    return null;
  }

  return !isMobile ? (<Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
    <Form.Item label="Дата" name="docDate"><DatePicker format="DD.MM.YYYY" allowClear={false} /></Form.Item>
      <Form.Item label="Вид" name="vid"><Select options={storeDocVids} /></Form.Item>
      {getObjectIn()}
      {getObjectOut()}
      <Form.Item label="Комментарий" name="comment"><Input /></Form.Item>
      <Form.Item label=" ">
        <Space>
          {(item && id && item.active) ? <Popconfirm title="Подтверждение" description="Деактивировать?" onConfirm={onDeactivate}>
            <Button className="sport-btn">Деактивировать</Button>
          </Popconfirm> : null}
          {(item && id && !item.active) ? <Popconfirm title="Подтверждение" description="Активировать?" onConfirm={onActivate}>
            <Button className="sport-btn">Активировать</Button>
          </Popconfirm> : null}
          {(item && id && !item.active) ? <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}>
            <Button className="sport-btn">Удалить</Button>
          </Popconfirm> : null}
          <ButtonReport id={id} vid={7} begPer={item?.docDate} endPer={item?.docDate} />
          <LogMonitor vid={13} id={id}/>
          <Button className="sport-btn" onClick={onSave}>Сохранить</Button>
          {/* <Button className="sport-btn" onClick={onCancel}>Закрыть</Button> */}
        </Space>
      </Form.Item>
    </Form>) : (
    <>
      <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 4 }} colon={false} disabled={loading} layout="inline">
        <Form.Item label="Дата" className="record-form-item-with-margin-top-mobile" name="docDate">
          <DatePicker format="DD.MM.YYYY" allowClear={false} className="records-form-item-mobile"/>
        </Form.Item>
        <Form.Item className="record-form-item-with-margin-top-mobile" label="Вид" name="vid">
          <Select className="records-form-item-mobile" options={storeDocVids} />
        </Form.Item>
        {getObjectIn()}
        {getObjectOut()}
        <Form.Item className="record-form-item-with-margin-top-mobile" label="Коммент." name="comment">
          <Input className="records-form-item-mobile"/>
        </Form.Item>
      </Form>
      { (item && id && item.active) ?
        (<div className="stock-osv-item-line-triple" style={{ paddingRight: 0, marginTop: "4px" }}>
          <Popconfirm  title="Подтверждение" description="Деактивировать?" onConfirm={onDeactivate}
            placement="top" getPopupContainer={(trigger) => trigger.closest('.stock-osv-item-line-triple')} overlayClassName="centered-popconfirm">
            <Button style={{width: "100%"}}>Деактив.</Button>
          </Popconfirm>
          <ButtonReport id={id} vid={7} begPer={item?.docDate} endPer={item?.docDate} compact={true}/>
          <Button style={{width: "100%"}} onClick={onSave}>Сохранить</Button>
        </div>) : 
        ((item && id && !item.active) ? (
          <div className="stock-osv-doc-line-quad" style={{ paddingRight: 0, marginTop: "4px" }}>
            <Popconfirm title="Подтверждение" description="Активировать?" onConfirm={onActivate}
              placement="top" getPopupContainer={(trigger) => trigger.closest('.stock-osv-doc-line-quad')} overlayClassName="centered-popconfirm">
              <Button style={{width: "100%"}}>Актив.</Button>
            </Popconfirm>
            <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}
              placement="top" getPopupContainer={(trigger) => trigger.closest('.stock-osv-doc-line-quad')} overlayClassName="centered-popconfirm">
              <Button style={{width: "100%"}}>Удал.</Button>
            </Popconfirm>
            <ButtonReport id={id} vid={7} begPer={item?.docDate} endPer={item?.docDate} compact={true}/>
            <Button style={{width: "100%"}} onClick={onSave}>Сохран.</Button>
          </div>) :         
          (<div className="stock-osv-item-line-double" style={{ paddingRight: 0, marginTop: "4px" }}>
            <ButtonReport id={id} vid={7} begPer={item?.docDate} endPer={item?.docDate} compact={true}/>
            <Button style={{width: "100%"}} onClick={onSave}>Сохранить</Button>
          </div>))
      }
    </>
    )     
}

export default StockDocMain;